export { LoggerService } from 'sce-core';
// #TODO-LIBRARY



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/core/logger.service.ts